import { createFileRoute } from '@tanstack/react-router'

import { DeletedDocumentsScreen } from '@/features/admin'

export const Route = createFileRoute('/_auth/admin/deleted')({
  component: DeletedDocumentsScreen,
})
